import { partnerCards } from "@/data/content";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Partners() {
  return (
    <section id="partners" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <span className="eyebrow">Host · Speak · Collaborate</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
              Host, speak, facilitate, or collaborate with Aura
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-[var(--aura-charcoal-2)]">
              Aura is open to collaborating with experts, brands, venues,
              creators, trainers, communities, and organizations.
            </p>
          </div>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {partnerCards.map((p) => (
            <div
              key={p.title}
              className="p-7 rounded-2xl bg-white border border-black/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <h3 className="font-display text-xl leading-snug">{p.title}</h3>
              <p className="mt-3 font-body text-sm text-[var(--aura-charcoal-2)] leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <button
            onClick={() => scrollTo("enquiry")}
            data-testid="partners-cta"
            className="inline-flex items-center gap-2 font-ui text-sm px-6 py-3 rounded-full bg-[var(--aura-charcoal)] text-[var(--aura-ivory)] hover:bg-[var(--aura-teal)] transition-colors"
          >
            Become an Aura Partner <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
